// extracted by mini-css-extract-plugin
module.exports = {"whyWeMadeThis":"why-we-made-this-simple_whyWeMadeThis__elfif","heading":"why-we-made-this-simple_heading__rtpOZ","description":"why-we-made-this-simple_description__n1iae"};